import React, { useEffect, useRef, useState } from 'react';
import { Slider, Tooltip, ConfigProvider } from 'antd';
import { DownArrowSVG } from '../constants';

interface AdjustLTVAmountProps {
  ltv: number;
  min_ltv?: number;
  max_ltv: number;
  setLtv: (value: number) => void;
  clean?: boolean;
}

export const AdjustLTVAmount = ({ ltv, min_ltv = 0, max_ltv, setLtv, clean }: AdjustLTVAmountProps) => {
  let adjustedMinLtv = Math.ceil(min_ltv * 100)
  let adjustedMaxLtv = max_ltv * 100
  let adjustedLtv = Math.ceil(ltv * 100)

  const handleSetLtv = (v: number) => {
    if (v >= adjustedMaxLtv) {
      v = adjustedMaxLtv
    }

    if (v <= adjustedMinLtv) {
      v = adjustedMinLtv
    }

    setLtv(v/100)
  }

  const [innerLTV, setInnerLTVState] = useState(adjustedLtv)

  useEffect(() => {
    if (!innerLTV) {
      setInnerLTVState(adjustedLtv)
    }
  }, [adjustedLtv])

  const setInnerLTV = (v: number) => {
    v = Math.round(v / 5) * 5

    if (v >= Math.ceil(adjustedMaxLtv)) {
      v = Math.ceil(adjustedMaxLtv)
    }

    if (v <= adjustedMinLtv) {
      v = adjustedMinLtv
    }

    setInnerLTVState(v)
  }

  const [isSelected, setIsSelected] = useState(false)

  const toggleIsSelected = () => {
    setIsSelected(!isSelected)
  }

  const sliderRef = useRef<HTMLDivElement>(null)

  const sliderConfig = {
    components: {
      Slider: {
        trackBg: "#355C7D",
        trackHoverBg: "#355C7D",
        trackBgDisabled: "#CCD3DB",
        handleActiveColor: "#355C7D",
        handleColor: "#355C7D",
        handleLineWidth: 3,
        handleLineWidthHover: 4,
        handleSize: 10,
        handleSizeHover: 12,
      },
      Tooltip: {
        colorBgSpotlight: "#355C7D",
        colorTextLightSolid: "#F5FAFF",
        fontFamily: "Inter",
        fontSize: 10,
      }
    },
  }

  if (clean) {
    return (
      <div className='adjust-loan-amount adjust-ltv-amount'>
        <div>
          <Tooltip 
            placement="right" 
            title={`Max LTV: ${Math.ceil(adjustedMaxLtv)}%`} 
            open 
            autoAdjustOverflow={false} 
            classNames={{ root: 'light' }}
            getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
          >
            <div ref={sliderRef}>
              <ConfigProvider theme={sliderConfig}>
                <Slider
                  value={innerLTV}
                  onChange={setInnerLTV}
                  onAfterChange={handleSetLtv}
                  defaultValue={adjustedLtv}
                  tooltip={{ open: true, formatter: (v) => `${v}%` }}
                />
              </ConfigProvider>
            </div>
          </Tooltip>
        </div>
      </div>
    )
  }

  return (
    <div className='adjust-loan-amount adjust-ltv-amount'>
      {
        !isSelected ?
          <div className='label' onClick={toggleIsSelected}>
            ADJUST LTV
            <div className='arrow-container'>
              <DownArrowSVG/>
            </div>
          </div>
          :
          <div>
            <Tooltip 
              placement="right" 
              title={`Max LTV: ${Math.ceil(adjustedMaxLtv)}%`} 
              open 
              autoAdjustOverflow={false} 
              classNames={{ root: 'light' }}
              getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
            >
              <div ref={sliderRef}>
                <ConfigProvider theme={sliderConfig}>
                  <Slider
                    value={innerLTV}
                    onChange={setInnerLTV}
                    onAfterChange={handleSetLtv}
                    defaultValue={adjustedLtv}
                    tooltip={{ open: true, formatter: (v) => `${v}%` }}
                  />
                </ConfigProvider>
              </div>
            </Tooltip>
          </div>
      }
    </div>
  )
}

